import React, { useEffect, useRef } from 'react';
import loadScript from 'lib/loadScript';

import './styles.themed.scss';

const elementId = 'embed-program-guide';

/**
 * ProgramGuide component
 * @param {string} url
 * @returns {Element}
 */
const ProgramGuide = ({ url }) => {
  const pymParentRef = useRef(null);

  useEffect(() => {
    loadScript('https://nodeassets.nbcnews.com/cdnassets/pym/1.3.2/pym.min.js')
      .then(() => {
        if (window.pym && url && typeof url === 'string') {
          const targetElement = document.getElementById(elementId);

          // The target element must exist to set the height in pixels on the iframe
          if (!targetElement) {
            console.error('<ProgramGuide /> : Target element not found', elementId);
            return;
          }

          // Strip Pym query string params from url that might have been copied.
          const urlWithoutPymQueryStringParams = url.replace(/&(childId|parentUrl)=[^&]+/g, '');
          // Pym adds iframe and establishes communication for controlling height.
          //* Each iframe needs to be created with a new pym Parent, otherwise subsequent iframes
          //* will overwrite the prior ones
          pymParentRef.current = new window.pym.Parent(elementId, urlWithoutPymQueryStringParams);

          pymParentRef.current.onMessage('height', (height) => {
            console.log('<ProgramGuide /> height:', height);
          });

          if (pymParentRef.current.onMessage) {
            pymParentRef.current.onMessage('navigateMessage', (message) => {
              console.log('Navigation message received:', message);
            });
          }
        }
      })
      .catch(() => {
        // Silently handle script load failures.
      });

    return () => {
      // This mimics the original behavior
    };
  }, []);

  return (
    <div data-testid="programGuideEmbed" className="program-guide__embed">
      <div id={elementId} />
    </div>
  );
};

export default ProgramGuide;
